import React, { useState } from 'react';
import { Card, Collapse, Tag, Typography, Space } from 'antd';
import PreferenceControls from './PreferenceControls';
import EventRow from './EventRow';
import TestNotificationButton from './TestNotificationButton';

const { Text } = Typography;
const { Panel } = Collapse;

const CategoryCard = ({
    category,
    availableChannels,
    frequencies,
    onCategorySave,
    onEventSave,
    onEventReset,
    onTestSent,
    saving = false,
}) => {
    const [eventsExpanded, setEventsExpanded] = useState(false);
    const hasOverride = category.override !== null && category.override !== undefined;
    const enabledChannels = category.effectivePreference?.channels ?? [];

    return (
        <Card
            title={
                <Space size="small" wrap>
                    <span>{category.displayName}</span>
                    {hasOverride && <Tag color="gold">Customized</Tag>}
                </Space>
            }
            style={{ marginBottom: 16 }}
        >
            {category.description && (
                <div className="notification-preferences__category-description">
                    <Text type="secondary">{category.description}</Text>
                </div>
            )}

            <PreferenceControls
                value={category.effectivePreference}
                availableChannels={availableChannels}
                frequencies={frequencies}
                onSave={(body) => onCategorySave(category.key, body)}
                saving={saving}
            />

            {enabledChannels.length > 0 && (
                <div className="notification-preferences__test-section">
                    <Text strong className="notification-preferences__test-section-title">
                        Test delivery
                    </Text>
                    <Space wrap>
                        {enabledChannels.map((channel) => {
                            const channelAvailable =
                                availableChannels?.[channel]?.available !== false;
                            return (
                                <TestNotificationButton
                                    key={channel}
                                    channel={channel}
                                    disabled={!channelAvailable}
                                    onSent={onTestSent}
                                />
                            );
                        })}
                    </Space>
                    <Text
                        type="secondary"
                        className="notification-preferences__test-section-hint"
                    >
                        Tests use the saved channels, not unsaved edits.
                    </Text>
                </div>
            )}

            {category.events && category.events.length > 0 && (
                <Collapse
                    ghost
                    className="notification-preferences__events-collapse"
                    activeKey={eventsExpanded ? ['events'] : []}
                    onChange={(keys) => setEventsExpanded(keys.includes('events'))}
                >
                    <Panel header={`Show individual events (${category.events.length})`} key="events">
                        {category.events.map((event) => (
                            <EventRow
                                key={event.eventKey}
                                event={event}
                                availableChannels={availableChannels}
                                frequencies={frequencies}
                                onSave={onEventSave}
                                onReset={onEventReset}
                                saving={saving}
                            />
                        ))}
                    </Panel>
                </Collapse>
            )}
        </Card>
    );
};

export default CategoryCard;
